import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { User } from '@/lib/api/types';

export function useManagers() {
    return useQuery({
        queryKey: ['managers'],
        queryFn: async () => {
            const response = await api.get('/api/v1/tapanel/get-managers');
            return response.data?.managers || [];
        },
    });
}
